import * as BX from "main";
import {Reflection} from 'main.core';

const namespace = Reflection.namespace('BX.Citrus.Aproduction3.Catalog.Element');

const SLIDER_LINK = 'b-productGallery__sliderLink';
const SLIDER_LINK_ACTIVE = `${SLIDER_LINK}_active`;
const MAIN_LINK = 'b-productGallery__mainLink';
const MAIN_LINK_ACTIVE = `${MAIN_LINK}_active`;

export class Gallery {
    constructor() {
        this.$window = $(window);

        BX.ready(() => this.onReady());
        BX.addCustomEvent('onAjaxSuccess', () => this.onReady());
        BX.addCustomEvent('onComponentAjaxHistorySetState', () => this.onReady());

        // @todo Отрефакторить: вместо создания нового экземпляра swiper после каждого ресайза, нужно создавать/переключать на одну из двух нужных версий свайпера.
        this.$window.on('resize', () => this.transformMainSwiper());
    }

    onReady() {
        this.productSliderSwiper = new Swiper('.b-productGallery__container.swiper-container', {
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 10,
            direction: 'vertical',
            navigation: {
                nextEl: '.b-productGallery__slider .swiper-button-next',
                prevEl: '.b-productGallery__slider .swiper-button-prev',
            },
        });

        $(`.${SLIDER_LINK}`).on('click', function (event) {
            const index = $(this).parent().index();

            event.preventDefault();
            const alreadyActive = $(this).hasClass(SLIDER_LINK_ACTIVE);
            if (alreadyActive) return;

            // min
            $(`.${SLIDER_LINK_ACTIVE}`).removeClass(SLIDER_LINK_ACTIVE);
            $(this).addClass(SLIDER_LINK_ACTIVE);

            // big
            $(`.${MAIN_LINK_ACTIVE}`).removeClass(MAIN_LINK_ACTIVE);
            $(`.${MAIN_LINK}`).eq(index).addClass(MAIN_LINK_ACTIVE);
        });

        const gallery = this;
        $(`.${MAIN_LINK}`).initPhotoSwipe({
            history: false,
            events: {
                afterChange: function() {
                    const index = this.getCurrentIndex();

                    // min
                    const slide = gallery.productSliderSwiper.slides[index];
                    if (!$(slide).hasClass('swiper-slide-visible')) gallery.productSliderSwiper.slideTo(index, 0);
                    $(`.${SLIDER_LINK_ACTIVE}`).removeClass(SLIDER_LINK_ACTIVE);
                    $(`.${SLIDER_LINK}`).eq(index).addClass(SLIDER_LINK_ACTIVE);

                    // big
                    $(`.${MAIN_LINK_ACTIVE}`).removeClass(MAIN_LINK_ACTIVE);
                    $(`.${MAIN_LINK}`).eq(index).addClass(MAIN_LINK_ACTIVE);
                }
            },
            loop: false,
            bgOpacity: .8
        });

        this.transformMainSwiper();
    }

    transformMainSwiper() {
        if (this.$window.width() <= '1023') {
            $('.b-productGallery__main').addClass('swiper-container');
            $('.b-productGallery__wrap').addClass('swiper-wrapper');
            $('.b-productGallery__mainLink').addClass('swiper-slide')
            // $('.b-productGallery__mainLink').addClass('swiper-slide flex relative').removeClass('hidden absolute');

            this.productMainSwiper = new Swiper('.b-productGallery__main.swiper-container', {
                slidesPerView: 1,
                paginationClickable: true,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.b-productGallery__btn_next.swiper-button-next',
                    prevEl: '.b-productGallery__btn_prev.swiper-button-prev',
                },
            });
        }
    }

}

namespace.Gallery = Gallery;
